// removed by extract-text-webpack-plugin
module.exports = {"large_desktop":"only screen and (min-width: 1201px)","desktop":"only screen and (min-width: 1025px) and (max-width: 1200px)","tablet":"only screen and (min-width: 768px) and (max-width: 1024px)","mobile":"only screen and (max-width: 767px)","heroArea":"heroArea__129gA","playButton":"playButton__1CN_Y","animatedScreens":"animatedScreens__10BUf","heroPhone":"heroPhone__2Q_eB","playerText":"playerText__2zVE1","gameChanger":"gameChanger__2607i","playerPerformance":"playerPerformance__1jfvR","videoPlayer":"videoPlayer__14-dj","videoPlayerButton":"videoPlayerButton__l_yF9","scheduleDemo":"scheduleDemo__-TqpE"};


//////////////////
// WEBPACK FOOTER
// ./components/Hero/style.css
// module id = tlK4
// module chunks = 0